import { Component, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import * as model from "../../../models";

@Component({
	selector: 'shipment-types-presentation',
	templateUrl: "./shipment-types.presentation.html",
	styles: [require("./shipment-types.presentation.scss")]
})

export class ShipmentTypesPresentation {

	@Input() set event(event: model.Event) {
		this._event = event;
		if (this._event) {
			this.shipmentTypesForm = this.createForm(this._event)
		} else {
			this.shipmentTypesForm = null;
		}
	}

	@Output() private saveDisabledShipmentTypes = new EventEmitter<string[]>();

	private shipmentTypesForm: FormGroup;
	private _event: model.Event;
	private shipmentTypesEnum = model.ShipmentTypes;
	private shipmentTypesKeys = Object.keys(model.ShipmentTypes);

	protected submitForm(shipmentTypesFormData) {
		const disabledShipmentTypes: string[] = this.shipmentTypesKeys
					.filter(stKey => !shipmentTypesFormData[stKey]);
		this.saveDisabledShipmentTypes.emit(disabledShipmentTypes);
	}

	private createForm(event: model.Event): FormGroup  {
		const controls: {[key: string]: FormControl} = Object.keys(this.shipmentTypesEnum)
			.map( stKey =>
				({
					name: stKey,
					control: new FormControl(event.disabledShipmentTypes ? event.disabledShipmentTypes.indexOf(stKey) === -1 : true)
				})
			)
			.reduce(
				(result, item) => {
					result[item.name] = item.control
					return result;
				},
				<{[key: string]: FormControl}>{}
			)
		return new FormGroup(controls);
	}
}



// WEBPACK FOOTER //
// ./src/app/components/event-components/shipment-types/shipment-types.presentation.ts